import { render, staticRenderFns } from "./Paywall.vue?vue&type=template&id=79abd058&scoped=true"
import script from "./Paywall.vue?vue&type=script&lang=js"
export * from "./Paywall.vue?vue&type=script&lang=js"
import style0 from "./Paywall.vue?vue&type=style&index=0&id=79abd058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79abd058",
  null
  
)

export default component.exports